import BaseSelect from "react-select";

const Select = ({ formik, name, value, options, ...props }) => {
  const customStyles = {
    control: (provided) => ({
      ...provided,
      height: 41,
      background: "#F8FBFF",
      border:
        formik.errors.position && formik.touched.position
          ? "1px solid #f24822"
          : "1px solid #edf3ff",
      borderRadius: "8px",
    }),
    indicatorSeparator: (provided) => ({
      ...provided,
      display: "none",
    }),
    valueContainer: (provided) => ({
      ...provided,
      height: 41,
      marginTop: "-2px",
      display: "flex",
      alignItems: "center",
      fontSize: 16,
    }),
    singleValue: (provided) => ({
      ...provided,
      height: 41,
      display: "flex",
      alignItems: "center",
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      display: "flex",
      alignItems: "center",
    }),
    placeholder: (provided) => ({
      ...provided,
      display: "flex",
      alignItems: "center",
      color: "#97adc6",
      fontSize: 16,
    }),
  };

  return (
    <BaseSelect
      styles={customStyles}
      isSearchable={false}
      name={name}
      value={value}
      onChange={(option) => formik.setFieldValue(name, option.value)}
      onBlur={() => formik.setFieldTouched(name)}
      options={options.map((el) => ({
        value: el.value,
        label: el.label,
      }))}
    />
  );
};

export default Select;
